import React from 'react'
import type { DetailCardGridProps } from './DetailCard.types'

const DetailCardGrid: React.FC<DetailCardGridProps> = ({
  children,
  className = '',
}) => {
  const classNames = ['ds-detail-card-grid', className]
    .filter(Boolean)
    .join(' ')

  return <div className={classNames}>{children}</div>
}

export default DetailCardGrid
